// BCM-898 · PA11 — Batch QA Release Rejected (slide 32). [Lavanya]
// Status 41 (Batch Not Accepted) resolves to PA11 unconditionally — it emits no
// pending requirement, so the resolver does not wait for one. Read-only, same
// card as PA10 with the rejected copy.
import React from "react";
import QAReleaseCard from "../components/common/QAReleaseCard";

const PA11QAReleaseRejected = ({ row, viewOnly, onRefresh }) => (
  <QAReleaseCard
    row={row}
    title="Batch QA Release Rejected"
    subText="QA has rejected the release of this batch in SAP. Post-Shipment documents cannot be processed for a rejected batch."
    rejected
    viewOnly={viewOnly}
    onRefresh={onRefresh}
  />
);

export default PA11QAReleaseRejected;
